<p-sidebar
  [(visible)]="visible"
  position="right"
  [style]="{ width: '50vw' }"
  [showCloseIcon]="false"
  (onHide)="close()"
>
  <div class="sidebar-container flex flex-column">

    <!-- Header -->
    <div class="sidebar-header">
      <p-button *ngIf="!readonly" label="{{ 'Key.InterviewCommonSave' | translate }}" (onClick)="save()" [disabled]="!form.name?.trim() || !form.durationMinutes || !form.availabilityRuleID || !form.userIntegrationID"></p-button>
    </div>

    <!-- Name -->
    <div class="event-name-wrapper">
      <input
        pInputText
        class="event-name-input"
        [(ngModel)]="form.name"
        placeholder="{{ 'Key.InterviewEventNamePlaceholder' | translate }}"
        [attr.readonly]="readonly ? true : null"
        [ngClass]="{'p-disabled': readonly}"
      />
    </div>

    <!-- Badge + subtitle -->
    <div class="flex align-items-center gap-2 mb-1 mt-1">
      <p-badge [value]="'Key.InterviewBadgeOneOnOne' | translate"></p-badge>
    </div>
    <p class="subtitle-text">{{ 'Key.InterviewEventTypeSubtitle' | translate }}</p>

    <!-- Duration -->
    <div class="section mt-5">
      <label class="text-sm text-blue-400 font-medium mb-2 block">{{ 'Key.InterviewChoiceOfDuration' | translate }}</label>
      <p-dropdown
        [options]="durationOptions"
        [(ngModel)]="form.durationMinutes"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'Key.InterviewDurationPlaceholder' | translate }}"
        styleClass="w-full"
        [disabled]="readonly"
      ></p-dropdown>
    </div>

    <!-- Availability Weekly Hours -->
    <div class="section mt-5">
      <div class="flex align-items-center justify-content-between mb-3">
        <div class="rule-selector-wrapper">
          <button class="rule-selector text-sm text-blue-400 font-medium" type="button" (click)="!readonly && toggleRuleMenu($event)" [ngClass]="{'cursor-default p-disabled': readonly}">
            <span>{{ selectedRule ? selectedRule.name : ('Key.InterviewChooseRule' | translate) }}</span>
            <i class="pi" *ngIf="!readonly && availabilityRules?.length > 0" [ngClass]="ruleMenuOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </button>
          <div class="overlay-menu rule-menu" *ngIf="ruleMenuOpen && !readonly && availabilityRules?.length > 0" (click)="$event.stopPropagation()">
            <div
              class="rule-menu-item"
              *ngFor="let rule of availabilityRules"
              (click)="onRuleSelect(rule)"
            >
              <span>{{ rule.name }}</span>
              <i class="pi pi-check check-icon" *ngIf="selectedRule?.id === rule.id"></i>
            </div>
          </div>
          <div class="mt-2" *ngIf="availabilityRules == null || availabilityRules?.length == 0">
              <span class="text-red-500 font-medium text-sm">{{ 'Key.InterviewPleaseCreateRule' | translate }}</span>
            </div>
        </div>
      </div>
      <app-availability-weekly-hours
        *ngIf="selectedRule"
        [availabilityRule]="selectedRule"
        [readonly]="true"
      ></app-availability-weekly-hours>
    </div>

    <div class="divider"></div>

    <!-- Meeting Platform -->
    <div class="section mt-3">
      <label class="text-sm text-blue-400 font-medium">{{ 'Key.InterviewMeetingPlatformSelect' | translate }}</label>
      <div class="platform-grid mt-2">
        <div
          *ngFor="let integration of displayedIntegrations"
          class="platform-card"
          [class.platform-card--selected]="selectedIntegrationId === integration.id"
          (click)="!readonly && onIntegrationSelect(integration)"
          [ngClass]="{'cursor-default': readonly}"
        >
          <img [src]="getIconPath(integration.integrationType)" class="platform-icon" />
          <span class="platform-label">{{ getIntegrationLabel(integration.integrationType) }}</span>
        </div>
        <div class="mt-2" *ngIf="displayedIntegrations == null || displayedIntegrations?.length == 0">
            <span class="text-red-500 font-medium text-sm">{{ 'Key.InterviewPleaseCreateIntegration' | translate }}</span>
          </div>
      </div>
    </div>

  </div>
</p-sidebar>
